import React, { useState } from 'react'
import { Overlay } from 'common/styleguide/Overlay'
import styles from './SignupModal.scss'
import { loginMessages } from 'common/styleguide/LoginModal'
import { Modal } from 'common/styleguide/Modal'
import { CTA } from 'common/styleguide/CTA'
import { CircleSpinner } from 'common/spinners'
import { errorMessage } from 'lib/styleguide/base.scss'
import fetchJSON from 'lib/fetchJSON'
import { Msg } from 'lib/localization'
import { FormattedMessage as T } from 'react-intl'

export const SIGNUP_MODAL = 'SIGNUP_MODAL'

export const SignupModal = ({ title, children, beforeRefresh, intl, onRequestLogin, onRequestClose }) => {
  const [name, setName] = useState('')
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [loginPending, setLoginPending] = useState(false)
  const [error, setError] = useState()

  const onSubmit = e => {
    e.preventDefault()
    if (!name || !email || !password) {
      setError(<T id='SignupModal.missingField' defaultMessage='Please fill out all the fields.' />)
      return
    }
    setLoginPending(true)
    const onError = () => {
      setError(<T id='LoginModal.genericError' defaultMessage='Unable to create account. There may already be an account with this email, please try logging in.' />)
      setLoginPending(false)
    }
    fetchJSON('/users.json?apikey=x&version=3', { user: { display_name: name, email, password, email_on_update: 1 } })
      .then(res => {
        if (res.errors) {
          onError()
        } else {
          if (beforeRefresh) beforeRefresh()
          window.location.reload(true)
        }
      })
      .catch(onError)
  }

  return (
    <Overlay
      maxWidth={760}
      maxHeight={630}
      onRequestClose={onRequestClose}>
      <Modal onRequestClose={onRequestClose} contentPadding={false}>
        <div className={styles.SignupModal}>
          <div className={styles.left}>
            <div className={styles.logo}>
              <svg width='43' height='30' viewBox='0 0 43 30' fill='none' xmlns='http://www.w3.org/2000/svg'>
                <path fillRule='evenodd' clipRule='evenodd' d='M25.4901 17.5978C25.1512 17.9549 24.7684 18.3868 24.3222 18.934C23.4444 20.0107 21.9868 21.7404 21.1111 22.7796L21.1105 22.7803L21.1105 22.7804L21.1099 22.781L21.1077 22.7836C20.7883 23.1626 20.5469 23.4492 20.4399 23.5778C16.1558 28.7304 13.6738 29.7328 10.948 29.9278C10.4663 29.9754 9.935 30 9.34606 30C4.61435 30 0 26.0216 0 21.0043C0 16.352 3.30976 12.5088 7.76232 12.004L7.77651 12.0024C8.12988 11.9623 8.80532 11.8857 9.63381 12.004C10.3623 12.1081 11.5064 12.447 11.687 12.9892C10.5327 12.7505 9.92178 12.7945 9.29794 12.8678C7.66639 13.0598 6.51979 13.5432 5.69325 14.1475C3.84886 15.4958 2.59958 17.5458 2.59958 20.016C2.59958 23.972 5.88106 27.1687 9.802 27.1687C11.7829 27.1687 13.6279 26.3917 14.9687 25.1127C15.2417 24.8868 15.4765 24.6733 15.658 24.4782C17.4149 22.59 20.7918 18.5686 20.7918 17.6869C20.7918 16.7069 18.5988 14.4647 16.3315 13.1056C13.1027 11.1702 12.9739 9.68722 12.9739 8.55296C12.9739 4.91338 18.5808 3.01662 23.9544 3.5386C25.2668 8.35942 29.0663 8.63127 29.7439 8.67975L29.7498 8.68018C31.7349 8.82233 32.7089 8.66343 33.8925 8.37911C35.0761 8.0948 35.4513 7.82723 35.4513 7.82723C35.4513 7.82723 35.4513 8.23514 34.5404 8.8409C33.6294 9.44665 31.0991 10.3707 29.3815 10.3707C25.7343 10.3707 23.7512 8.81609 21.924 6.77079C17.7874 7.10315 17.397 8.32256 17.6566 8.71096C18.2581 9.61055 24.6546 13.9956 25.2184 13.8976C25.3884 13.8681 25.6767 13.7122 26.0758 13.4965C27.3661 12.7991 29.8151 11.4754 33.1706 11.7678C38.1045 11.9014 42.1187 15.8841 42.1187 20.8284C42.1187 25.8579 38.1738 29.9281 32.9146 29.9281C28.5657 29.9281 25.6722 26.8345 26.1713 26.0889C26.1772 26.08 26.1831 26.0717 26.1887 26.0641C27.5179 27.3069 29.6913 28.6212 31.8837 28.6212C36.0757 28.6212 39.4739 25.3795 39.4739 21.3808C39.4739 17.382 36.7346 14.737 32.5637 14.3605C30.7612 14.1978 29.7196 14.5468 28.607 15.1052C27.6525 15.5843 26.4259 16.6433 25.4854 17.6124C25.487 17.6075 25.4885 17.6026 25.4901 17.5978Z' fill='#FA6400' />
                <path fillRule='evenodd' clipRule='evenodd' d='M29.3511 6.34772C30.6777 6.30139 32.1665 5.13961 32.1054 3.39046C32.0443 1.64131 30.2814 0.57733 28.6736 0.321961C25.4678 -0.187223 22.2311 0.765862 21.3526 2.32003C21.3526 2.32003 21.6975 2.18577 22.1711 2.06162C23.4069 1.73769 24.6432 1.89375 25.6611 2.4861C26.1137 2.74944 26.1896 3.33711 26.1896 3.40588C26.1896 5.49286 28.0245 6.39404 29.3511 6.34772Z' fill='#FA6400' />
              </svg>
            </div>
            <div className={styles.title}>
              <T id='SignupModal.whySignupTitle' defaultMessage='Get Inspired, Not Lost' />
            </div>
            <div className={styles.feature}>
              <svg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
                <path fillRule='evenodd' clipRule='evenodd' d='M1.6001 11.9C1.6001 8.8624 4.05069 6.40002 7.07378 6.40002C10.0969 6.40002 12.5475 8.8624 12.5475 11.9C12.5475 14.9376 7.07378 22.4 7.07378 22.4C7.07378 22.4 1.6001 14.9376 1.6001 11.9ZM4.58569 11.9C4.58569 10.5192 5.69946 9.40004 7.07373 9.40004C8.448 9.40004 9.56177 10.5192 9.56177 11.9C9.56177 13.2809 8.448 14.4 7.07373 14.4C5.69946 14.4 4.58569 13.2809 4.58569 11.9Z' fill='#616161' />
                <path d='M10.3453 22.9104C12.7891 23.0781 14.3716 22.607 15.2779 21.4691C15.9607 20.6119 16.1271 19.7991 16.2454 17.9221C16.4242 15.0845 16.8831 14.4 19.6001 14.4V12.8C15.8436 12.8 14.8739 14.2464 14.6491 17.8133C14.5516 19.3599 14.4268 19.9696 14.0264 20.4723C13.5039 21.1283 12.4253 21.4494 10.4549 21.3141L10.3453 22.9104Z' fill='#616161' />
                <path fillRule='evenodd' clipRule='evenodd' d='M16 4.63757C16 2.73906 17.5316 1.20007 19.4211 1.20007C21.3105 1.20007 22.8421 2.73906 22.8421 4.63757C22.8421 6.53609 19.4211 11.2001 19.4211 11.2001C19.4211 11.2001 16 6.53609 16 4.63757ZM17.866 4.63757C17.866 3.77452 18.5621 3.07507 19.421 3.07507C20.2799 3.07507 20.976 3.77452 20.976 4.63757C20.976 5.50061 20.2799 6.20007 19.421 6.20007C18.5621 6.20007 17.866 5.50061 17.866 4.63757Z' fill='#616161' />
              </svg>
              <div className={styles.featureTitle}><T id='SignupModal.tip1Title' defaultMessage='Powerful route planning tools' /></div>
              <T id='SignupModal.tip1' defaultMessage='Use our route planner to plot your commute, bikepacking adventure, or next Gran Fondo.' />
            </div>
            <div className={styles.feature}>
              <svg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
                <path fillRule='evenodd' clipRule='evenodd' d='M7.00001 1L17 1.01C18.1 1.01 19 1.9 19 3V21C19 22.1 18.1 23 17 23H7.00001C5.90001 23 5.01001 22.1 5.01001 21V3C5.01001 1.9 5.90001 1 7.00001 1ZM7.00001 19H17V5H7.00001V19Z' fill='black' fill-opacity='0.54' />
              </svg>
              <div className={styles.featureTitle}><T id='SignupModal.tip2Title' defaultMessage='Enjoy your ride' /></div>
              <T id='SignupModal.tip2' defaultMessage='Get turn-by-turn voice navigation, Live Logging, offline maps, and more.' />
            </div>
            <div className={styles.feature}>
              <svg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
                <path fillRule='evenodd' clipRule='evenodd' d='M20.34 3.03L20.5 3C20.78 3 21 3.22 21 3.5V18.62C21 18.85 20.85 19.03 20.64 19.1L15 21L9 18.9L3.66 20.97L3.5 21C3.22 21 3 20.78 3 20.5V5.38C3 5.15 3.15 4.97 3.36 4.9L9 3L15 5.1L20.34 3.03ZM9 16.78L15 18.89V7.22L9 5.11V16.78Z' fill='black' fill-opacity='0.54' />
              </svg>
              <div className={styles.featureTitle}><T id='SignupModal.tip3Title' defaultMessage='Discover routes' /></div>
              <T id='SignupModal.tip3' defaultMessage='Find a new ride in your backyard, or start planning your next trip.' />
            </div>
          </div>
          <div className={styles.right}>
            <div className={styles.title}><T id='SignupModal.title' defaultMessage='Sign up or login to save' /></div>
            <div className={styles.subtitle}>
              <T
                id='SignupModal.login'
                defaultMessage='Already have an account? <a>Log in here</a>'
                values={{ a: (...c) => <a href='javascript:;' onClick={() => { onRequestClose(); onRequestLogin() }}>{c}</a> }} />
            </div>
            <form className={styles.form} onSubmit={onSubmit}>
              {error && <p className={errorMessage}>{error}</p>}
              <div>
                <label>
                  <T id='SignupModal.name' defaultMessage='Name' />
                </label>
                <input className={styles.largeText} autoFocus value={name} onChange={e => setName(e.target.value)} />
              </div>
              <div>
                <label>
                  <Msg m={loginMessages.email} />
                </label>
                <input className={styles.largeText} type='email' value={email} onChange={e => setEmail(e.target.value)} />
              </div>
              <div>
                <label>
                  <Msg m={loginMessages.password} />
                </label>
                <input className={styles.largeText} type='password' value={password} onChange={e => setPassword(e.target.value)} />
              </div>
              <CTA button type='submit' disabled={loginPending} onClick={onSubmit}>
                {loginPending
                  ? <CircleSpinner light size={12} />
                  : <T id='SignupModal.createAccount' defaultMessage='Create a Free Account' />}
              </CTA>
              <div className={styles.disclaimer}>
                <T
                  id='SignupModal.disclaimer'
                  defaultMessage='By creating an account you are accepting our <terms>Terms of Service</terms> and <privacy>Privacy Policy</privacy>. We may occasionally send you emails with product updates, and you can unsubscribe at any time.'
                  values={{
                    terms: (...chunks) => <a href='/terms'>{chunks}</a>,
                    privacy: (...chunks) => <a href='/privacy'>{chunks}</a>
                  }} />
              </div>
            </form>
          </div>
        </div>
      </Modal>
    </Overlay>
  )
}
